export default __webpack_public_path__ + "static/media/HAI.da87b2af.svg";